<template>
  <div class="containerFull noPadding pNotas">
    <div class="notes-container pure-g">
       <div
        class="pure-u-xl-4-24 pure-u-lg-4-24 pure-u-md-6-24 pure-u-sm-8-24 pure-u-12-24 mixedNotes"
        v-for="(item, index) in  items"
        :key="index"
      >
        <!-- <div class="notes-col" v-for="(item, index) in  items" :key="index">-->
        <!--<div class="col-sm-12 col-md-6" v-for="(item, index) in  items" :key="index">-->
        <mvideo :from="from" :config="item" v-if="item.entrada=='T' || item.entrada=='R'" @goToNote="goToNote"  @goToNotes="goToNotes"></mvideo>
        <youtube-note :from="from" :config="item" v-if="item.entrada=='Y'" @goToNote="goToNote"  @goToNotes="goToNotes"></youtube-note>
        <text-note :from="from" :config="item" v-if="item.entrada=='FB' || item.entrada=='TW' || item.entrada=='I' || item.entrada=='PD' || item.entrada=='TK'" @goToNote="goToNote"  @goToNotes="goToNotes"></text-note>
        <!--<pd :config="item" v-if="item.entrada=='PD'" @goToNote="goToNote"></pd>
        <facebook-note :config="item" v-if="item.entrada=='FB'" @goToNote="goToNote"></facebook-note>
        <twitter-note :config="item" v-if="item.entrada=='TW'" @goToNote="goToNote"></twitter-note>
        <instagram-note :config="item" v-if="item.entrada=='I'" @goToNote="goToNote"></instagram-note>-->
      </div>
    </div>
    <div class="button-circle-more secondary" v-if="LastEvaluatedKey>0">
      <button class="button circle-more tooltip tooltip-left" data-tooltip="Cargar más" @click="loadMore">
        <svg viewBox="0 0 18 18">
          <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
            <rect
              id="Rectángulo_redondeado_903"
              data-name="Rectángulo redondeado 903"
              width="2"
              height="18"
              rx="1"
              transform="translate(179 753)"
              fill="#fff"
            />
            <rect
              id="Rectángulo_redondeado_903_copia"
              data-name="Rectángulo redondeado 903 copia"
              width="18"
              height="2"
              rx="1"
              transform="translate(171 761)"
              fill="#fff"
            />
          </g>
        </svg>
      </button>
    </div>
    <!-- END BUTTON CIRCLE -->
  </div>
  <!--- end container -->
</template>


<script>
import mvideo from "@/components/mvideo";
import textNote from "@/components/textNote";
import youtubeNote from "@/components/youtubeNote";

//import keywordsNotes from "@/components/keywordsNotes";
//import fiNotes from "@/components/fiNotes";

export default {
  name: "panelNotas",
  components: {
    mvideo,
    youtubeNote,
    textNote
  },
  props: ["items", "LastEvaluatedKey", "from"],
  data() {
    return {
    }
  },
  mounted() {
    console.log('aqui wee',this.items);
    console.log('mounted panelNotas');
  },
  methods: {
    goToNote(params) {
      this.$emit("goToNote", params);
    },
    goToNotes(params) {
      this.$emit("goToNotes", params);
    },
    loadMore() {
      this.$emit("loadMore");
    }
  }
};
</script>
<style>
.top-actions button {
  margin: 0px 5px !important;
  font-size: 14px !important;
  padding: 10px 15px !important;
}

.mixedNotes {
  padding: 5px;
}
.pNotas .card.card-medios .user-avatar .user-name {
  font-size: 15px;
}

.pNotas .user-avatar .data-avatar .user {
  font-size: 11px;
}

.pNotas .card {
  border-top-right-radius: 5px !important;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;

  min-height: 270px;
  max-height: 270px;
}

.pNotas .card-actions {
  position: absolute;
  bottom: 0px;
  width: 95%;
}

.pNotas .video-post {
  max-height: 270px;
  min-height: 270px;
  border-top-right-radius: 5px !important;
  border-top-left-radius: 5px !important;
  background-color: #fff;
}

.pNotas .video-post .video {
  border: none !important;
}
</style>